import { AttachmentState } from "@powersync/web"

type Executor = {
  execute: (sql: string, params?: unknown[]) => Promise<unknown>
}

/**
 * Queue a download for every SYNCED row that has no local file.
 *
 * The SDK can produce such rows itself. Its startup check clears the URI of
 * an archived row whose file is missing but leaves it archived, and when the
 * photo is watched again (switching back to its project) the SDK restores a
 * row with `has_synced` straight to SYNCED. Nothing downloads it after that,
 * so the photo shows a skeleton forever. Every pre-filesystem row hit this
 * on upgrade, because its `indexeddb://` URI reads as missing (ADR 0001).
 */
export async function requeueMissingDownloads(
  db: Executor,
  tableName: string,
): Promise<void> {
  await db.execute(
    `UPDATE ${tableName} SET state = ?
     WHERE state = ? AND (local_uri IS NULL OR local_uri = '')`,
    [AttachmentState.QUEUED_DOWNLOAD, AttachmentState.SYNCED],
  )
}
